export default __webpack_public_path__ + "static/FrieslandCampina-e0a581af5e7a2709e29b72c9678d0df4.png";